import { combineReducers } from 'redux'
import { combineEpics } from 'redux-observable'
import { byClientActions, byClientEpic, byClientReducer, ByClientState } from './byClient'
import { byObjectActions, byObjectEpic, byObjectReducer, ByObjectState } from './byObject'
import { byUserActions, byUserEpic, byUserReducer, ByUserState } from './byUser'
import { byManagerActions, byManagerEpic, byManagerReducer, ByManagerState } from './byManager'
import { byProjectActions, byProjectEpic, byProjectReducer, ByProjectState } from './byProject'
import { byTaskActions, byTaskEpic, byTaskReducer, ByTaskState } from './byTask'
import { byWorkActions, byWorkEpic, byWorkReducer, ByWorkState } from './byWork'

export const statisticsActions = {
    byClientActions,
    byManagerActions,
    byObjectActions,
    byProjectActions,
    byTaskActions,
    byWorkActions,
    byUserActions
}

export interface StatisticsState {
    byClient: ByClientState,
    byManager: ByManagerState,
    byObject: ByObjectState,
    byProject: ByProjectState,
    byTask: ByTaskState,
    byWork: ByWorkState,
    byUser: ByUserState,
}

export const statisticsReducer = combineReducers<StatisticsState>({
    byClient: byClientReducer,
    byManager: byManagerReducer,
    byObject: byObjectReducer,
    byProject: byProjectReducer,
    byTask: byTaskReducer,
    byWork: byWorkReducer,
    byUser: byUserReducer,
})

export const statisticsEpic = combineEpics(byClientEpic, byManagerEpic, byObjectEpic, byUserEpic, byProjectEpic, byTaskEpic, byWorkEpic)